import axios from 'axios';

import { type UserConsent } from '../../shared/types/userConsent';

const addUserConsent = async (email: string, userConsent: UserConsent): Promise<void> => {
    await axios.post('/api/add-user-consent', { email, userConsent });
};

export { addUserConsent };
